"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IssueLastCommentRendererFactory = void 0;
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const DataPill_1 = __importDefault(require("@opsbase/web-chips/DataPill"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const get_1 = __importDefault(require("lodash/get"));
const react_1 = __importDefault(require("react"));
const IssueLastCommentRendererFactory = (viewField, idx, pdf = false) => (item) => {
    const comments = (0, get_1.default)(item, 'comments', []);
    if (!comments || !comments.length)
        return null;
    const lastComment = comments[comments.length - 1];
    const commentors = (0, get_1.default)(item, 'commentors', []);
    const commentor = commentors.find(c => c.id === lastComment.staffId);
    const userBit = pdf ? (react_1.default.createElement(Text_1.default, { style: {
            borderTop: `1px dashed ${lib_palette_1.default.BackgroundGrey.main}`,
            paddingTop: 4,
            marginTop: 4,
        } }, commentor === null || commentor === void 0 ? void 0 : commentor.title)) : (react_1.default.createElement(DataPill_1.default, { value: (commentor === null || commentor === void 0 ? void 0 : commentor.title) || 'Unknown', avatarUrl: commentor === null || commentor === void 0 ? void 0 : commentor.profileImageUrl, type: DataType_1.default.STAFF, textWidth: '100%' }));
    return (react_1.default.createElement(Vertical_1.default, null,
        react_1.default.createElement(Text_1.default, { withBreaks: true, style: { fontStyle: 'italic', fontSize: '0.8em' } }, lastComment.title),
        react_1.default.createElement(Pane_1.default, null, userBit)));
};
exports.IssueLastCommentRendererFactory = IssueLastCommentRendererFactory;
exports.default = exports.IssueLastCommentRendererFactory;
